const pageNameKey = "connectedGatewaysListContainer";

export const connectedGatewaysListContainerEn = {
  [pageNameKey]: { description: "Connected Gateways" },
};

export const connectedGatewaysListContainerPtBr = {
  [pageNameKey]: { description: "Gateways conectados" },
};

export const connectedGatewaysListContainerDe = {
  [pageNameKey]: { description: "Verbundene Gateways" },
};

export const connectedGatewaysListContainerZhHans = {
  [pageNameKey]: {
    description: "已连接的网关",
  },
};

export const connectedGatewaysListContainerIt = {
  [pageNameKey]: { description: "Gateway connessi" },
};

export const connectedGatewaysListContainerEs = {
  [pageNameKey]: { description: "Gateways conectados" },
};

export const connectedGatewaysListContainerNl = {
  [pageNameKey]: {
    description: "Verbonden gateways",
  },
};

export const connectedGatewaysListContainerTr = {
  [pageNameKey]: {
    description: "Bağlı Ağ Geçitleri",
  },
};
